import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-choose-us',
  templateUrl: './choose-us.component.html',
  styleUrls: ['./choose-us.component.css']
})
export class ChooseUsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
